var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payments",
    clipPath: "url(#clip0_3166_15496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6665 9.33317V3.99984C12.6665 3.2665 12.0665 2.6665 11.3332 2.6665H1.99984C1.2665 2.6665 0.666504 3.2665 0.666504 3.99984V9.33317C0.666504 10.0665 1.2665 10.6665 1.99984 10.6665H11.3332C12.0665 10.6665 12.6665 10.0665 12.6665 9.33317ZM6.6665 8.6665C5.55984 8.6665 4.6665 7.77317 4.6665 6.6665C4.6665 5.55984 5.55984 4.6665 6.6665 4.6665C7.77317 4.6665 8.6665 5.55984 8.6665 6.6665C8.6665 7.77317 7.77317 8.6665 6.6665 8.6665ZM15.3332 4.6665V11.9998C15.3332 12.7332 14.7332 13.3332 13.9998 13.3332H2.6665V11.9998H13.9998V4.6665H15.3332Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3166_15496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.291b09567d25dfa77d97f39cc308588f.svg";
export { ForwardRef as ReactComponent };